module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sex-age"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.average) + " " + _vm._s(_vm.stddev))]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "myChart"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e1fe0a0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Chart.vue
// module id = 191
// module chunks = 0